import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Copy = ({
  size = {
    height: 16,
    width: 14,
  },
  color,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1993 11.9987C11.9461 11.9987 12.3195 11.9987 12.6047 11.8534C12.8556 11.7255 13.0595 11.5216 13.1874 11.2707C13.3327 10.9855 13.3327 10.6121 13.3327 9.86536V3.46536C13.3327 2.71863 13.3327 2.34526 13.1874 2.06004C13.0595 1.80916 12.8556 1.60519 12.6047 1.47736C12.3195 1.33203 11.9461 1.33203 11.1993 1.33203H7.46602C6.71928 1.33203 6.34591 1.33203 6.06069 1.47736C5.80981 1.60519 5.60584 1.80916 5.47801 2.06004C5.33268 2.34526 5.33268 2.71863 5.33268 3.46536M4.79935 14.6654H8.53268C9.27942 14.6654 9.65279 14.6654 9.938 14.52C10.1889 14.3922 10.3929 14.1882 10.5207 13.9374C10.666 13.6521 10.666 13.2788 10.666 12.532V6.13203C10.666 5.38529 10.666 5.01193 10.5207 4.72671C10.3929 4.47583 10.1889 4.27185 9.938 4.14402C9.65279 3.9987 9.27942 3.9987 8.53268 3.9987H4.79935C4.05261 3.9987 3.67924 3.9987 3.39403 4.14402C3.14315 4.27185 2.93917 4.47583 2.81134 4.72671C2.66602 5.01193 2.66602 5.38529 2.66602 6.13203V12.532C2.66602 13.2788 2.66602 13.6521 2.81134 13.9374C2.93917 14.1882 3.14315 14.3922 3.39403 14.52C3.67924 14.6654 4.05261 14.6654 4.79935 14.6654Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
